var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2684 8.42319C13.2442 9.39902 13.2442 10.9832 12.2684 11.9607C11.2926 12.9365 9.7084 12.9365 8.7309 11.9607C7.75507 10.9849 7.75507 9.40069 8.7309 8.42319C9.7084 7.44569 11.2917 7.44569 12.2684 8.42319",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 10.1899C3 9.64073 3.12667 9.0974 3.37167 8.59657V8.59657C4.63417 6.01573 7.42417 4.35657 10.5 4.35657C13.5758 4.35657 16.3658 6.01573 17.6283 8.59657V8.59657C17.8733 9.0974 18 9.64073 18 10.1899C18 10.7391 17.8733 11.2824 17.6283 11.7832V11.7832C16.3658 14.3641 13.5758 16.0232 10.5 16.0232C7.42417 16.0232 4.63417 14.3641 3.37167 11.7832V11.7832C3.12667 11.2824 3 10.7391 3 10.1899Z",
    stroke: "#8A90A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.aad8d0e43b1051a9a365ac2f0ef8104e.svg";
export { ForwardRef as ReactComponent };